let swiperInstances = [];

const swipperSlider = () => {
  // Destroy existing Swiper instances
  swiperInstances.forEach(swiper => swiper.destroy(true, true));
  swiperInstances = [];

  const sections = document.querySelectorAll('.swiper');

  sections.forEach((section) => {
    const desktopSlider = section.classList.contains('desktop_slider');
    const mobileSlider = section.classList.contains('mobile_slider');
    let isStatus = true;
    let centerSlide = false;
    let centeredSlidesBounds = false;
    let spaceBetween = ((mobileSlider || desktopSlider) && window.innerWidth > 768) ? 20 : 4;

    if (mobileSlider && window.innerWidth <= 768) {
      spaceBetween = section.dataset.spaceBetweenMobile || spaceBetween;
    }

    if (!desktopSlider && section.classList.contains('image-grid-container') && window.innerWidth >= 769) {
      section.classList.remove('swiper');
      isStatus = false;
    }

    if (!mobileSlider && section.classList.contains('image-grid-container') && window.innerWidth <= 768) {
      section.classList.remove('swiper');
      isStatus = false;
    }
    if(window.innerWidth < 769){
      centerSlide = true;
      centeredSlidesBounds = true;
    }
    console.log("space", spaceBetween, section.dataset.productsPerRowTab, section.dataset.productsPerRow);

    if (isStatus) {
      const swiper = new Swiper(section, {
        direction: 'horizontal',
        slidesPerView: 1.6,
        spaceBetween: parseInt(spaceBetween),
        loop: false,
        centeredSlides: centerSlide,
        centeredSlidesBounds: centeredSlidesBounds,
        autoplay: section.dataset.autoplay === 'true' ? {
          delay: parseInt(section.dataset.autoplaySpeed) || 5000,
          disableOnInteraction: false,
        } : false,
        breakpoints: {
          768: {
            slidesPerView: parseInt(section.dataset.productsPerRowTab) || 1,
            spaceBetween: parseInt(spaceBetween),
          },
          1140: {
            slidesPerView: parseInt(section.dataset.productsPerRow) || 1,
            spaceBetween: parseInt(spaceBetween),
          },
        },
        scrollbar: {
          el: '.carousel-scrollbar',
          draggable: true,
          hide: false,
        },
        navigation: {
          nextEl: '.pager-next',
          prevEl: '.pager-prev',
        },
        on: {
          afterInit: function (swiper) {
            const interval = setInterval(() => {
              const scrollbarDrag = section.querySelector('.swiper-scrollbar-drag');
              if (scrollbarDrag) {
                const dragWidth = scrollbarDrag.offsetWidth;
                if (dragWidth === 0) {
                  swiper.update();
                } else {
                  clearInterval(interval);
                }
              }
            }, 100);
          },
          slideChange: function () {
            const isLastSlide = this.activeIndex === this.slides.length - 1;
            
            if (isLastSlide && this.params.centeredSlides) {
              section.closest(".page-width").classList.add("last-slide-active");
            }else{
              section.closest(".page-width").classList.remove("last-slide-active");
            }
          }
        }
      });
      if(centerSlide){
        section.querySelector(".swiper-wrapper").style.transform = "translate3d(0px, 0px, 0px)";
      }
      setTimeout(function() {
          let swiperWrapper = section.querySelector('.swiper-wrapper');
          if (swiperWrapper.style.gap !== '0px' && swiperWrapper.style.gap !== '0') {
            swiperWrapper.style.gap = '0';
            swiperWrapper.style.overflow = 'visible';
            section.querySelectorAll('.swiper-slide').forEach((item, index) => {
              item.style.flex = 'none';
            });
          }
        }, 1000);
      swiperInstances.push(swiper);
    }
  });

  document.querySelectorAll(".carousel__pager").forEach((item) => {
    item.style.display = "flex";
  });
};
let flktyInstances = [];
function isElementVisible(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0 &&
    rect.left < window.innerWidth &&
    rect.right > 0
  );
}

const flikity_slider = () => {
  try {
    if (flktyInstances.length > 0) {
      flktyInstances.forEach(flkty => flkty.destroy());
    }
    flktyInstances = [];

    document.querySelectorAll('.hero_flickity').forEach((section) => {
      section.offsetHeight;

      const isMobile = window.innerWidth < 768;
      const autoplayStatus = (isMobile ? section.dataset.autoplay : section.dataset.autoplayDesktop) == 'true'
        ? Number(section.dataset[isMobile ? 'speed' : 'speedDesktop'])
        : false;

      const isDraggable = !!autoplayStatus;
      const pageDots = section.dataset.dots == 'true';
      const pageArrows = section.dataset.arrows == 'true';
      const fade = section.dataset.fade || false;
      const cellAlign = section.dataset.center || 'left';

      const flkty = new Flickity(section, {
        wrapAround: true,
        fade: fade,
        prevNextButtons: pageArrows,
        cellAlign: cellAlign,
        contain: true,
        autoPlay: autoplayStatus,
        pageDots: pageDots,
        pauseAutoPlayOnHover: false,
        draggable: true
      });

      flktyInstances.push(flkty);
      section.querySelectorAll('.slideshow__slide').forEach((item) => {
        item.classList.add('is-fade');
      });
      
    });
  } catch (e) {
    console.error("Flickity error:", e);
  }
};


// Re-initialize on resize with debounce
let resizeTimeout;
let previousWidth = window.innerWidth;

window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const currentWidth = window.innerWidth;
    if (currentWidth !== previousWidth) {
      previousWidth = currentWidth;
      flikity_slider();
      swipperSlider();
    }
  }, 300);
});



document.querySelectorAll(".carousel__pager").forEach((item, index) => {
  item.style.display = "flex"; // Corrected: Removed the extra semicolon inside the string
});

// Call the function initially
swipperSlider();
window.onload = function() {
  flikity_slider();
}
// Reinitialize on Shopify section load
document.addEventListener('shopify:section:load', () => {
  swipperSlider();
  flikity_slider();
});

document.addEventListener('shopify:block:select', (event) => {
  const blockId = event.detail.blockId;
  const cellElement = document.querySelector(`[data-id="${blockId}"]`);

  if (cellElement && cellElement.closest('.hero_flickity.flickity-enabled')) {
    const sliderElement = cellElement.closest('.hero_flickity');

    // Access Flickity instance
    const flickityInstance = Flickity.data(sliderElement);

    if (flickityInstance) {
      // Find the index of the cellElement within the Flickity slider
      const selectedIndex = Array.from(sliderElement.querySelectorAll('.slideshow__slide')).indexOf(cellElement);

      // Select the slide using Flickity's API
      flickityInstance.select(selectedIndex);
    }
  }
});

// Create a mutation observer
var mutationObserver = new MutationObserver(() => {
var body = document.body;

  if (body.classList.contains("snize-instant-widget-is-open")) {
    // Lock scroll
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    body.style.setProperty("overflow", "hidden", "important");
    body.style.setProperty("padding-right", `${scrollbarWidth}px`, "important");
  } else {
    // Restore scroll
    body.style.overflow = "";
    body.style.paddingRight = "";
  }
});

// Start observing body class changes
mutationObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ["class"],
});